module.exports = "<wache-map class=\"map-view-container\" enable-alarm-map-feature=\"true\"></wache-map>"